import { Controller } from "@hotwired/stimulus"

/**
 * Controller for managing tabs in settings.
 * Supports configurable active/inactive classes and content toggling.
 */
export default class extends Controller {
  static values = { 
    current: String,
    activeClass: { type: String, default: "btn-cta" },
    inactiveClass: { type: String, default: "btn-gray-4" }
  }
  static targets = ["tab", "content"]

  connect() {
    // A link or a redirect may name the tab to open (#account-mappings).
    const fromHash = window.location.hash.slice(1)
    if (fromHash && this.tabTargets.some(tab => tab.dataset.tab === fromHash)) {
      this.currentValue = fromHash
    }
    // Set initial state based on current value or first tab
    if (!this.currentValue && this.hasTabTarget) {
      this.currentValue = this.tabTargets[0].dataset.tab
    }
    this.updateUI()
  }

  switchTab(event) {
    this.currentValue = event.currentTarget.dataset.tab
    this.updateUI()
  }

  updateUI() {
    this.updateTabStyles()
    this.showContent()
  }

  updateTabStyles() {
    const activeClasses = this.activeClassValue.split(' ')
    const inactiveClasses = this.inactiveClassValue.split(' ')

    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tab === this.currentValue
      
      if (isActive) {
        tab.classList.remove(...inactiveClasses)
        tab.classList.add(...activeClasses)
      } else {
        tab.classList.remove(...activeClasses)
        tab.classList.add(...inactiveClasses)
      }
    })
  }

  showContent() {
    this.contentTargets.forEach(content => {
      if (content.dataset.tab === this.currentValue) {
        content.classList.remove('hidden')
      } else {
        content.classList.add('hidden')
      }
    })
  }
}

